import React from "react";
import Types from "prop-types";
import axios from "axios";
import queryString from "query-string";

import LoadingSpinner from "../LoadingSpinner";
import ChallengeFullName from "./ChallengeFullName";
import SimpleConfirmationChallenge from "./SimpleConfirmationChallenge";

export const SIMPLE_CONFIRMATION_CHALLENGE = "SIMPLE_CONFIRMATION_CHALLENGE";
export const FULL_NAME_CHALLENGE = "FULL_NAME_CHALLENGE";
export const RECOVERY_KIND_MERCHANT = "merchant";

export class ChallengeLoader extends React.Component {
  constructor(props) {
    super(props);
    const {
      clientId,
      otp,
      phoneNumber,
      email,
      verificationId,
      emailOnly,
    } = queryString.parse(props.location.search);
    this.state = {
      challenge: null,
      loading: true,
      session: { clientId, phoneNumber, otp, email, verificationId, emailOnly },
    };
  }

  componentDidMount() {
    document.title = "Recovery | Careem";
    const { location } = this.props;
    const {
      clientId,
      otp,
      verificationId,
      phoneNumber,
      email,
      emailOnly,
      fallbackTo,
    } = queryString.parse(location.search);
    if ((!phoneNumber && !email) || !clientId || (!otp && !verificationId)) {
      this.props.history.replace("/session_unknown");
    } else {
      if (email && emailOnly === "true" && fallbackTo !== "customer") {
        this.fetchChallengesForEmail({ email, clientId, otp, verificationId });
      } else {
        this.fetchChallenges({ phoneNumber, clientId, otp, verificationId });
      }
    }
  }

  fetchChallenges(session) {
    const { phoneNumber, clientId, otp, verificationId } = session;
    const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/recovery/challenges/${clientId}`;
    return axios
      .get(endpoint, { params: { phoneNumber, otp, verificationId } })
      .then((res) => res.data)
      .then((res) => {
        let challenge = res.challenges[0];
        this.setState({ challenge, loading: false });
      })
      .catch(() => this.props.history.push("/session_unknown"));
  }

  fetchChallengesForEmail(session) {
    const { email, clientId, otp } = session;
    const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/recovery/challenges/${clientId}`;
    return axios
      .get(endpoint, { params: { email, otp } })
      .then((res) => res.data)
      .then((res) => {
        let challenge = res.challenges[0];
        this.setState({ challenge, loading: false });
      })
      .catch((ex) => {
        console.error("Error fetching challenges for email", ex);
        return this.props.history.push("/session_unknown");
      });
  }

  verifyChallenge(type, { recaptcha, answer }) {
    const { clientId, otp, verificationId, phoneNumber } = this.state.session;
    const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/recovery/notification/${clientId}`;

    return axios
      .post(endpoint, {
        phoneNumber,
        otp,
        verificationId,
        challenges: [{ challengeIdentifier: type, challengeAnswer: answer }],
      })
      .then((res) => res.data);
  }

  redirectToLogin() {
    const { clientId, email } = this.state.session;
    this.props.history.replace(
      `/login?clientId=${encodeURIComponent(clientId)}&emailOnly=true&email=${encodeURIComponent(email)}&showApple=false&showGoogle=false`
    );
  }

  verifyChallengeByEmail(type, answer) {
    const { clientId, otp, verificationId, email } = this.state.session;
    const endpoint = `${process.env.REACT_APP_IDENTITY_SERVICES_SAG_HOST}/recovery/notification/${clientId}`;

    return axios
      .post(endpoint, {
        email,
        otp,
        verificationId,
        kind: RECOVERY_KIND_MERCHANT,
        challenges: [{ challengeIdentifier: type, challengeAnswer: answer }],
      })
      .then((res) => res.data)
      .then((data) => {
        alert(`Password recovery link is sent to the email: ${this.state.session.email} successfully`);
        this.redirectToLogin();
        return data;
      });
  }

  onNoHandler() {
    this.redirectToLogin();
  }

  render() {
    const { challenge, loading } = this.state;

    if (loading) return <LoadingSpinner />;

    switch (challenge.challengeIdentifier) {
      case FULL_NAME_CHALLENGE:
        return (
          <ChallengeFullName
            challenge={challenge}
            verifyChallenge={this.verifyChallenge.bind(
              this,
              FULL_NAME_CHALLENGE
            )}
            phoneNumber={this.state.session.phoneNumber}
          />
        );
      case SIMPLE_CONFIRMATION_CHALLENGE:
        return (
          <SimpleConfirmationChallenge
            email={this.state.session.email}
            onYes={this.verifyChallengeByEmail.bind(this, SIMPLE_CONFIRMATION_CHALLENGE, "YES")}
            onNo={this.onNoHandler.bind(this)}
          />
        );
      default:
        return "Recovery password challenges are not configured for this client";
    }
  }
}
ChallengeLoader.propTypes = {
  location: Types.object.isRequired,
  history: Types.object.isRequired,
};

export default ChallengeLoader;
